// extracted by mini-css-extract-plugin
export var close = "name-generator-module--close--4dnQV";
export var generator = "name-generator-module--generator--0uWoy";
export var generatorImage = "name-generator-module--generatorImage---5afx";
export var generatorModal = "name-generator-module--generatorModal--4AHfs";
export var generatorsContainer = "name-generator-module--generatorsContainer--Rb+iG";
export var overlay = "name-generator-module--overlay--KAKbL";
export var resultsTable = "name-generator-module--resultsTable--2KFMk";
export var resultsTableHeaderRow = "name-generator-module--resultsTableHeaderRow--99dt6";
export var title = "name-generator-module--title--W-Ev+";